var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (this.$root.publisher)?_c('video',{ref:"pub_video",staticClass:"bg-black",attrs:{"autoplay":"","controls":""}}):_c('video',{ref:"sub_video",staticClass:"bg-black",attrs:{"id":"sub","controls":""}})}
var staticRenderFns = []

export { render, staticRenderFns }